import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import ModelEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class ModelNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('guide-selling')
    }

    render() {
        return (
            <div>
                <ModelEditForm />
            </div>
        );
    }
}

export default ModelNew


// WEBPACK FOOTER //
// ./src/guided-selling/new.component.jsx